import { render, staticRenderFns } from "./DeclineLoans.vue?vue&type=template&id=32064d56&scoped=true&"
import script from "./DeclineLoans.vue?vue&type=script&lang=js&"
export * from "./DeclineLoans.vue?vue&type=script&lang=js&"
import style0 from "./DeclineLoans.vue?vue&type=style&index=0&id=32064d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32064d56",
  null
  
)

export default component.exports